import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


import { PostSubmitModalComponent } from '../../../modals/post-submit-modal/post-submit-modal.component';

interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-left-sidebar',
    templateUrl: './left_sidebar.component.html',
    styleUrls: ['./left_sidebar.component.css']
})
export class LeftSidebarComponent implements OnInit {
    @Input() Username: string;  // Input property to receive username    menuItems: MenuItem[];  // Array to hold menu items
    menuItems: MenuItem[];  // Array to hold menu items

    @Output() postSubmitComplete = new EventEmitter<void>();
    @Output() mediaUrlsChange = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() postContent = new EventEmitter<string>();
    @Output() onSave = new EventEmitter<void>();      

    constructor(
        private modalService: NgbModal,
        private router: Router
    ) {
        // Define menu items - this could instead be loaded from a service
        this.menuItems = [
            { icon: 'fa-house', label: 'Home', link: '/' },
            { icon: 'fa-compass', label: 'Explore', link: '/explore' },
            { icon: 'fa-bell', label: 'Notifications', link: '/notifications' },
            // Add more items as needed
        ];
    }

    ngOnInit(): void {
        // Additional initialization can be done here
    }

    navigateToProfile(): void {
        this.router.navigate(['/', this.Username]);
    }

    isProfileActive(): boolean {
        return this.router.url === `/${this.Username}`;
    }

    openPostSubmitModal(): void {
        const modalRef = this.modalService.open(PostSubmitModalComponent, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg'
        });

        //modalRef.componentInstance.postSubmit.subscribe((comment: string) => {
        //    if (comment.length > 0) {
        //        // Send refresh emit to parent.
        //    }
        //});

        modalRef.componentInstance.mediaUrlsChangeModal.subscribe((media: any[]) => {
            this.mediaUrlsChange.emit(media);  // Pass event up to Dashboard
        });

        modalRef.componentInstance.replyTypeChange.subscribe((type: any) => {
            this.replyTypeChange.emit(type);  // Pass event up to Dashboard
        });

        modalRef.componentInstance.postContent.subscribe((postContent: string) => {
            this.postContent.emit(postContent);  // Pass event up to Dashboard
        });

        modalRef.componentInstance.onSave.subscribe(() => {
            this.onSave.emit();
        });


    }

    refreshPosts() {
        // Emit the event to refresh posts
        this.postSubmitComplete.emit();
    }



}
